import { AuditType } from '../api';

export const getAuditTypeIcon = (auditType: AuditType): string => {
  switch (auditType) {
    case AuditType.ORDER_CREATED:
    case AuditType.ORDER_CREATED_FROM_VOUCHER:
      return '📝';
    case AuditType.ORDER_UPDATED:
      return '✏️';
    case AuditType.ORDER_DELETED:
      return '🗑️';
    case AuditType.EVENT_CREATED:
      return '📅';
    case AuditType.EVENT_UPDATED:
      return '🔄';
    case AuditType.EVENT_DELETED:
      return '❌';
    case AuditType.ORDER_CONVERTED_TO_VOUCHER:
    case AuditType.VOUCHER_CREATED_FROM_ORDER:
      return '🎁';
    case AuditType.VOUCHER_CONVERTED_TO_ORDER:
      return '🔄';
    case AuditType.PAYMENT_LINK_CREATED:
      return '💳';
    case AuditType.PAYMENT_LINK_PAID:
      return '✅';
    default:
      return '📋';
  }
};
